module.exports = {
  'Healthcare professional':'DEVICES.V2.FORM.OPTION.EQUIPMENT_OPERATOR.HEALTHCARE_PROFESSIONAL',
  'Patient':'DEVICES.V2.FORM.OPTION.EQUIPMENT_OPERATOR.PATIENT',
  'Other Caregiver':'DEVICES.V2.FORM.OPTION.EQUIPMENT_OPERATOR.OTHER_CAREGIVER',
  'None':'DEVICES.V2.FORM.OPTION.EQUIPMENT_OPERATOR.NONE'
};
